import { UNKNOWN_ACTION } from 'actions/ApiCaller';
import metricsTracker from 'utils/MetricsTracker';
// 10 seconds default timeout for all apis, unless overriden
const API_TIMEOUT = 10000;
export class Timeout {
    constructor(config) {
        // Storing only selective values instead of the entire context object
        // as the original fetchconfig object may end up getting larger and
        // it's useless to copy over all that data here.
        this.timeout = config.fk_api_timeout || API_TIMEOUT;
        this.action = config.action;
        this.timeoutID = undefined;
    }
    get start() {
        // Since the promise only rejects with a string, and TS' promise
        // constructor by default sets the return type as {} in versions < 3.5,
        // overriding the declaration to return a Promise<never> instead.
        return new Promise((_, reject) => {
            this.timeoutID = setTimeout(() => {
                const tag = this.action ? `action.${this.action}.timeout` : `${UNKNOWN_ACTION}.timeout`;
                metricsTracker.setCount(tag);
                // TODO: Take `acceptErrors` flag into account and reject a
                // proper error object rather than a string. This will simplify
                // error handling for timeouts to be inline with normal fetch
                // errors
                reject(`Request timeout: ${this.action}`);
            }, this.timeout);
        });
    }
    clear() {
        this.timeoutID && clearTimeout(this.timeoutID);
    }
}
class TimeoutError extends Error {
    constructor(...params) {
        super(...params);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TimeoutError);
        }
        this.name = 'TimeoutError';
    }
}
const TimeoutRegex = /Request timeout/;
export const isTimeoutError = (error) => {
    // TODO: eventually get rid of the regex check
    return typeof error === 'string' && TimeoutRegex.test(error);
};
